module.exports = __webpack_public_path__ + "img/map.ab0a8dcd.svg";